import { config } from './config'
import { ConsoleLogger } from '@beecode/msh-node-log/lib/console-logger'

export const logger = new ConsoleLogger({ logLevel: config.logLevel ?? 'debug' })
